import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const materialHeaderCuttingPlanQuantitySelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    if (bomItem.type !== 'MaterialHeader') {
      throw 'bomItemId is not a MaterialHeader'
    }

    return bomItem.cuttingPlans?.reduce(
      (acc, cuttingPlan) => acc + cuttingPlan.quantity,
      0
    )
  }
